<div class="bee-preloader-container"
     [ngClass]="{'absolute-centered': absoluteCentered, 'horizontal-display': horizontalDisplay}"
     [style.minWidth.px]="diameter"
     [style.minHeight.px]="diameter">
  <mat-spinner [diameter]="diameter"></mat-spinner>
  <span *ngIf="loadingText" class="loading-text" fxLayout="row" fxLayoutAlign="center center">
    {{ loadingText }}
  </span>
</div>
